import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-edit",
  templateUrl: "./med-icon-edit.component.html",
})
export class MedIconEditComponent extends SvgMixinComponent {}
